import React, { type DetailedHTMLProps, type HTMLAttributes } from 'react';

import styled from 'styled-components';

const DialogBodyDiv = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>) => <div data-dialog-body {...props}></div>;

export const DialogBody = styled(DialogBodyDiv)`
  height: 100%;
  overflow-x: auto;
`;
